// extracted by mini-css-extract-plugin
export default {"head__container":"styles_head__container__Acesd","head__text--title":"styles_head__text--title__79INm","head__icon--arrow-left":"styles_head__icon--arrow-left__jlw0+"};